import type { OfferProperty, ProductProperty } from '~/types/Catalog';

type CharacteristicProperty = OfferProperty | ProductProperty;

function getPropertyKey(property: CharacteristicProperty): string {
  return property.name.trim().replace(/\s+/g, ' ').toLocaleLowerCase('ru-RU');
}

function hasDisplayableValue(property: CharacteristicProperty): boolean {
  return Boolean(property.value) && String(property.value) !== '0';
}

export function getProductCharacteristics(
  productProperties: readonly ProductProperty[] = [],
  offerProperties: readonly OfferProperty[] = [],
): ProductProperty[] {
  const allProperties = [...productProperties, ...offerProperties];
  const hiddenPropertyKeys = new Set(
    allProperties.filter((property) => property.is_hidden_in_offer_card).map(getPropertyKey),
  );
  const propertiesByKey = new Map<string, ProductProperty>();

  for (const property of productProperties) {
    const key = getPropertyKey(property);

    if (!hasDisplayableValue(property) || hiddenPropertyKeys.has(key)) continue;

    propertiesByKey.set(key, {
      ...(property.group_id === undefined ? {} : { group_id: property.group_id }),
      name: property.name,
      value: property.value,
    });
  }

  for (const property of offerProperties) {
    const key = getPropertyKey(property);

    if (!hasDisplayableValue(property) || hiddenPropertyKeys.has(key)) continue;

    const productProperty = propertiesByKey.get(key);

    propertiesByKey.set(key, {
      ...(productProperty?.group_id === undefined ? {} : { group_id: productProperty.group_id }),
      name: productProperty?.name ?? property.name,
      value: property.value,
    });
  }

  return [...propertiesByKey.values()];
}
